module.exports = __webpack_public_path__ + "static/curso_altura-ef223a3f60522b50db9c75dd3c6bef3b.jpg";